import { lazy } from 'react';

export default [
    {
        path: '/manga-chat',
        exact: true,
        component: lazy(() => import(/* webpackChunkName: 'MangaChatLayout' */ './layout')),
    },
];
